import { useTranslation } from 'react-i18next';
import '../../scss/freelancing-guide-styling-components/freelancing-guide-title.style.scss';

export const FreelancingGuideHeader = () => {
  const { t } = useTranslation();
  return (
    <section className="freelancing-guide-title">
      <h2>{t("FREELANCER_GUIDE")}</h2>
    </section>
  );
};
